import { RoleId } from "../../user"
import { UserPermissions } from "../types"

/**
 * Returns default permissions for a role
 * @param role Role
 * @returns Permissions
 */
export function getDefaultPermissions(role: RoleId): UserPermissions {

    const readWriteOff = { read: false, write: false }

    const access = role === RoleId.Access
    const admin = role <= RoleId.Admin
    const serviceSpecialist = role === RoleId.ServiceSpecialist

    const climate = access || admin

    return {

        holdings: readWriteOff,

        currentHolding: { write: false },

        fields: readWriteOff,
        soil: readWriteOff,
        soilManagementPlan: false,
        mapLayers: readWriteOff,
        stocks: { ...readWriteOff, financialData: false },

        seedPlans: readWriteOff,
        nutritionPlans: readWriteOff,
        sprayPlans: {
            ...readWriteOff,
            auditPlans: {
                audit: true
            }
        },

        manure: readWriteOff,

        precision: false,

        imports: { enabled: false },

        exports: { enabled: false, holding: false, layers: false, boundaries: undefined, plans: false },
        connect: false,

        reports: { enabled: true },

        fieldDiary: readWriteOff,
        taskManagement: readWriteOff,
        asApplied: {
            viewDetails: false
        },

        yield: readWriteOff,
        shed: { ...readWriteOff, financialData: false },
        production: readWriteOff,
        planning: readWriteOff,

        climate: {

            read: climate,
            write: climate,

            chillUnits: admin,

            cropGrowth: {
                enabled: admin,
                dev: admin
            },

            risks: {
                enabled: admin,
                bydv: admin,
                potatoBlight: admin,
                frost: admin,
                hdm: admin,
                scab: admin,
                swd: admin,
                codlingMoth: admin,
                wheatDiseases: admin,
                barleyDiseases: admin,
                wheatLodging: admin
            }
        },

        satellite: {
            viewClouds: admin || serviceSpecialist
        },

        admin: {
            soilOptix: false
        }

    }

}
